import {
	GET_LINK_AGG,
	GET_LINK_AGG_FAIL,
	GET_LINK_AGG_SUCCESS,
	UPDATE_LINK_AGG,
	UPDATE_LINK_AGG_FAIL,
	UPDATE_LINK_AGG_SUCCESS,
	RESET_UPDATE_LINK_AGG,
} from '../../constants/switchConfiguration/linkAggregationConstants';

/**
 * Reducer function for managing switch link aggregation list.
 *
 * @param {object} state - Current state of the switch link aggregation list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */

export const linkAggReducer = (state = { linkAggData: [] }, action) => {
	switch (action.type) {
		case GET_LINK_AGG:
			return {
				...state,
				loading: true,
			};
		case GET_LINK_AGG_SUCCESS:
			return {
				...state,
				loading: false,
				linkAggData: action.payload,
			};
		case GET_LINK_AGG_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		default:
			return state;
	}
};

export const updateLinkAggReducer = (
	state = { successMessage: null, errorMessage: null },
	action
) => {
	switch (action.type) {
		case UPDATE_LINK_AGG:
			return {
				...state,
				loading: true,
			};
		case UPDATE_LINK_AGG_SUCCESS:
			return {
				...state,
				loading: false,
				successMessage: action.payload,
			};
		case UPDATE_LINK_AGG_FAIL:
			return {
				...state,
				loading: false,
				errorMessage: action.payload,
			};
		case RESET_UPDATE_LINK_AGG:
			return {
				...state,
				loading: false,
				errorMessage: null,
				successMessage: null,
			};
		default:
			return state;
	}
};
